/**
 * Kill switch for Server-Sent Events.
 *
 * Set to false and every feature that streams falls back to whatever it does
 * without a live channel — for MAIA that means the parsing spinner stays put
 * rather than advancing on its own. Nothing else in the app reads this.
 *
 * Consumers should check it before opening a stream:
 *
 * ```ts
 * if (!SSE_ENABLED) {
 *     return;
 * }
 * ```
 */
export const SSE_ENABLED = true;
